<template>
  <div>

    <!-- Recommendation Event -->
    <div class="row long_row urgent_notification_msg_row" v-if="latestUrgentNotification">
      <div class="col-12">

        <div class="card ace_sec crd_cal">
          <div class="card-body">

            <div class="row">
              <div class="col-2 row_icon">
                <div class="icon fas fa-user">
                </div>
              </div>

              <div class="col-12 row_detail">
                <div class="row cal_detail">
                  <div class="col-12 block_row">
                    <div class="row row_title">
                      <div class="col-11">
                         {{latestUrgentNotification.message.name}}
                      </div>
                      <div class="col-1 ic_container">
                        <span class="ic ic22-alert"></span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 block_row" v-html="latestUrgentNotification.message.text">
                  </div>
                </div>

                <div class="row action_row">
                  <!--
                  <div class="col-4 lnk_sec">
                    <span class="ic ic22-reply"></span>
                    <span class="lnk_txt">reply</span>
                  </div>
                  <div class="col-4 lnk_sec">
                    <span class="ic ic22-check"></span>
                    <span class="lnk_txt">mark as read</span>
                  </div>
                  -->
                  <div class="col-12 lnk_sec lnk_container" v-if="moreMessages > 1">
                    <span class="lnk_txt">
                      <b-link @click="navigateToChannel">{{moreMessages}} urgent messages</b-link>
                    </span>
                  </div>
                  <div class="col-12 lnk_sec lnk_container" v-else>
                    <span class="lnk_txt">
                      <b-link @click="navigateToChannel">
                        {{ $tf('readMsg') }}
                      </b-link>
                    </span>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- Recommendation Event -->

  </div>
</template>


<script>
  import { mapState, mapActions } from 'vuex'
  import { db, storage } from '../../../firebase'
  export default {
    name: 'learner-urgent',
    data: () => {
      return {
        urgentMessages: {},
        moreMessages :0
      }
    },
    mounted () {
      this.loadLearnerUrgent()
    },
    methods: {
      ...mapActions([
        'loadNotificationsForStudent'
      ]),
      async loadLearnerUrgent () {
        this.urgentMessages = await this.loadNotificationsForStudent()
      },
      navigateToChannel () {
        return this.$router.push({name: 'courseSectionChannel', params: {uuid: this.userObj.uuid, selectedCurrentChannel: this.latestUrgentNotification.channel, channelType: 'ALL', isShowBack: false}})
      }
    },
    computed: {
      ...mapState({
        'userObj': state => state.user.userObj
      }),
      latestUrgentNotification () {
        if (this.urgentMessages) {
          for (const [key, value] of Object.entries(this.urgentMessages)) {
            let messages = this.urgentMessages[key]
            if (messages.length > 0) {
              this.moreMessages = messages.length
              return {
                'channel': key,
                'message': messages[0]
              }
            }
          }
        }
        return null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerUrgent.vue